var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.828,
    height: 12.828,
    viewBox: "0 0 12.828 12.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16232",
    "data-name": "Group 16232",
    transform: "translate(1.414 1.414)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_552",
    "data-name": "Line 552",
    x1: 10,
    y2: 10,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_553",
    "data-name": "Line 553",
    x2: 10,
    y2: 10,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCross);
export default __webpack_public_path__ + "static/media/messageCross.cc1565d3a716a391117436260c14699d.svg";
export { ForwardRef as ReactComponent };